import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router'
import { DeviceNameHOC } from '../../hocs'
import DisplayExternalHTML from 'components/DisplayExternalHTML'

const NAV_MODULE_ICON = {
  tutorial:
    'https://s3.amazonaws.com/tpassets.devicebits.com/academy-assets/icons/navigation/Tutorials.svg',
  faq: 'https://s3.amazonaws.com/tpassets.devicebits.com/academy-assets/icons/navigation/FAQ.svg'
}

export const TYPE_NAMES = {
  tutorial: 'Tutorial',
  faq: 'FAQ'
}

const ResultContainer = styled.div`
  em {
    font-style: normal;
  }
`
const Title = styled.div`
  font-size: 17px;
  margin-bottom: 5px;
  font-weight: 600;
  a {
    color: var(--dark-gray);
  }
  div {
    display: inline;
  }

  img {
    height: 25px;
    width: 25px;
    margin: 5px 10px;
    display: inline-block;
    vertical-align: middle;
  }
`
const Description = styled.div`
  font-size: 14px;
`
const DeviceName = styled.div`
  font-size: 14px;
  margin-bottom: 5px;
  color: var(--main-color);
`

const ResultItem = ({ item, deviceName, onClick }) => {
  const titleContent = (
    <span>
      <Link to={item.url} onClick={onClick}>
        <DisplayExternalHTML message={item.title} />
      </Link>

      {NAV_MODULE_ICON[item.type] && (
        <img
          title={TYPE_NAMES[item.type]}
          alt={TYPE_NAMES[item.type]}
          src={NAV_MODULE_ICON[item.type]}
        />
      )}
    </span>
  )

  return (
    <ResultContainer>
      <Title>{titleContent}</Title>
      <DeviceName className="device-name">
        {deviceName(item.phonefk, true)}
      </DeviceName>
      <Description>
        <DisplayExternalHTML message={item.description} />
      </Description>
      <hr />
    </ResultContainer>
  )
}

ResultItem.propTypes = {
  item: PropTypes.shape({
    url: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    phonefk: PropTypes.number.isRequired
  }).isRequired,
  deviceName: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
}
export default DeviceNameHOC(ResultItem)
